<script>
  import { site } from './store.js'
  import Division from './Division.svelte'

  $: opened = $site.division.list.find(d => d.open)

</script>

<div class="division">
  <div class="inner">
    <div class="sub-title wow fadeInLeft" style="visibility: visible; animation-name: fadeInLeft;">Our divisions</div>
    <h2 class="wow fadeInLeft" data-wow-delay=".25s" style="visibility: visible; animation-delay: 0.25s; animation-name: fadeInLeft;">CAPABILITIES FROM<br>NOSE TO TAIL.</h2>
  </div>
  <div class="division-inner clear" class:opened style="background-image: url({ $site.division.background });">
    {#each $site.division.list as division, index}
      <Division {...division} {index} />
    {/each}
  </div>
</div>
